import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { DateTime } from 'luxon';
import { computed } from 'vue';

export function isAccountExpired(accountSettings, now = DateTime.local()) {
  const expiresAt = accountSettings?.expiresAt;
  if (expiresAt === null || expiresAt === undefined) {
    return false;
  }
  return DateTime.fromISO(expiresAt).diff(now).milliseconds < 0;
}

export default function useExpiredAccount() {
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const isExpired = computed(() => isAccountExpired(loggedInUserAccount.value?.accountSettings));
  return { isExpired };
}
